import { APIConstants, CREATE_SESSION_ACTION_TYPE } from '../../constants';
import { SSOPortalEligibilityData } from '../../dataModels/SSOPortalEligibilityData';
import axios from 'axios';

interface Params {
  refToken?: string;
  isFakeUser?: boolean;
}

export const createSsoSession = async (
  params: Params,
  config: (key: string) => string | undefined
): Promise<SSOPortalEligibilityData> => {
  try {
    const createSsoSessionUrl = `${config(APIConstants.CONFIG.SESSION_INIT_URL)}`;
    const options = {
      method: 'POST',
      url: createSsoSessionUrl,
      params: {
        ...params,
        actionType: CREATE_SESSION_ACTION_TYPE.CREATE,
      },
    };
    const response = await axios(options);

    return response.data;
  } catch (error) {
    throw error;
  }
};
